module.exports = __webpack_public_path__ + "img/HQ-OA-360V03NU.ebd3ed75.jpg";